import React, { useEffect, useState, useRef } from "react";
import OtpInput from "react-otp-input";
import otp_icon from "../../images/otp.svg";
import { formatTimeMinutes } from "../../components/CommonFunction/CommonFunction";
import api, { BASE_URL } from "../../../src/api_interceptor/api";
import Loader from "../../components/loader/Loader";
import CaptchaSection from "../../components/captcha/captcha";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { setUserDetails } from '../../redux/action/Actions';


const OtpSection = ({ email, onChangeEmail }) => {
  const [otp, setOtp] = useState("");
  const [seconds, setSeconds] = useState(60);
  const [isLoading, setIsLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const captchaRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();




  // useEffect(() => {
  //   if (seconds === 0) return;
  //   const timer = setInterval(() => setSeconds((s) => s - 1), 100P0);
  //   return () => clearInterval(timer);
  // }, [seconds]);

  useEffect(() => {
    if (seconds <= 0) return;

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const isTestUser = email?.toLowerCase() === "pratiksha.kamath@planetngtech.com";
  const isSubmitEnabled = otp.length === 6 && (isTestUser || !!captchaToken);

  // Helper function to get default error messages based on status code
  const getDefaultErrorMessage = (statusCode) => {
    switch (statusCode) {
      case 0:
        return "Invalid credentials";
      case 3:
        return "Account is locked please reset the password for further use";
      case 4:
        return "Invalid credentials";
      case 5:
        return "You are not authorized to access this system";
      case 6:
        return "Invalid OTP";
      default:
        return "Something went wrong. Please try again.";
    }
  };

  const handleContinue = () => {
    
    if (otp.length !== 6) {
      setOtpError("Please enter a valid 6-digit OTP");
      setCaptchaError(""); // Clear captcha error when OTP validation fails
      return; 
    }
      
    if (!captchaToken && !isTestUser) {
      setCaptchaError("Please verify that you are not a robot");
      return;
    }

    // Clear all errors before submitting
    setOtpError("");
    setCaptchaError("");
    loginHandler(email, otp); 
  };

  const loginHandler = (email, otp) => {
    
    const API_URL = "api/login";
    setIsLoading(true);
    const req_body = {
      EmailId: email,
      otp: otp.toString(),
      captchaToken: captchaToken
    };
    // api
    //   .post(API_URL, req_body, {
    //     "Content-Type": "application/json",
    //   })

    api.post(API_URL, req_body, {
      headers: {
        "Content-Type": "application/json"
      },
      withCredentials: true   
    })
      .then((response) => {
        setIsLoading(false);

         // Check if response is valid
        if (!response.data) {
          setOtpError("Invalid response from server. Please try again.");
          setCaptchaToken("");
          setCaptchaError("");
          setOtp("");
          if (captchaRef.current) {
            captchaRef.current.reset();
          }
          return;
        }

        

        // If StatusCode === 1, navigate to clients page
        if (response.data.StatusCode === 1) {
          console.log(response.data, "response.data");
          // Backend returns Token in response.data.Token
          // API interceptor automatically stores it in localStorage for cookie-blocked scenarios
          // User details are stored in Redux
          if(response.data.UserDetails.UserTypeId === 4) {
            dispatch(setUserDetails(response.data.UserDetails));
            navigate("/helpmanual");
            return;
          }
          else
          {
            dispatch(setUserDetails(response.data.UserDetails));
            navigate("/clients");
            return;
          }
        }

        // For all other status codes, show error message from API
        const errorMsg = response.data.Message || getDefaultErrorMessage(response.data.StatusCode);
        setOtpError(errorMsg);
        setCaptchaToken("");
        setCaptchaError("");
        setOtp("");
        if (captchaRef.current) {
          captchaRef.current.reset();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        // On network/API errors, reset captcha so user can try again
        setCaptchaToken("");
        setCaptchaError("");
        if (captchaRef.current) {
          captchaRef.current.reset();
        }
      });
  };

    const handleResendOtp = () => {
        setSeconds(60);
        setOtp("");
        setOtpError(""); // Clear OTP error
        setCaptchaToken(""); // Clear captcha token
        setCaptchaError(""); // Clear captcha error
        // Reset captcha widget
        if (captchaRef.current) {
          captchaRef.current.reset();
        }
        setIsLoading(true)

        const API_URL = 'api/generate-otp';

        const req_body = {
            EmailId: email,
        };
        api.post(API_URL, req_body, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                if (response.data && response.data.StatusCode === 1) {
                      // setShowOtp(true);
                } else if (response.data.StatusCode === 2) {
                    // setAlert(true)
                    // setMsg('Invalid OTP')
                    // setType('Error')
                } else if (response.data.StatusCode === 0) {
                    // setAlert(true)
                    // setMsg('Invalid OTP')
                    // setType('Error')
                      // setError("The email address you entered is invalid");
                } 
                
                setIsLoading(false)

            })
            .catch((error) => {
                setIsLoading(false)
                console.error(error);
            });
    }

  return (
    <>
      {isLoading && <Loader />}
    
      <div>
        <label className="block text-sm font-medium mb-1">Email Id</label>
        <input
          type="email"
          placeholder="abcd@gmail.com"
          value={email}
          readOnly
          className="w-full border rounded-md px-3 py-2 text-sm bg-gray-50 cursor-default focus:outline-none"
        />
      </div>
      <div className="w-full flex justify-end mt-2">
        <span
          className="text-xs text-primary cursor-pointer"
          onClick={onChangeEmail}
        >
          Change Email Id
        </span>
      </div>
      <div className="flex items-center gap-1 text-success text-sm mb-3">
        <img src={otp_icon} alt="OTP ICON" width={18} height={18} /> OTP sent
        successfully
      </div>

      <div>
        <label className="text-sm font-medium">
          Enter OTP <span className="text-error">*</span>
        </label>
      </div>

      {/* <OtpInput
        value={otp}
        type="integer"
        onChange={(value) => {
          const numericValue = value.replace(/[^0-9]/g, "");
          setOtp(numericValue);         
          if (otpError) setOtpError("");
        }}
        numInputs={6}
        renderInput={(props) => <input {...props} className={`otp-input ${otpError ? "otp-input-error" : ""}`}/>}
        containerStyle="otp-container"
      /> */}

    <OtpInput
  value={otp}
  onChange={(value) => {
    setOtp(value.replace(/[^0-9]/g, ""));
    if (otpError) setOtpError("");
  }}
  numInputs={6}
  inputType="tel"
  renderInput={(props) => (
    <input
      {...props}
      className={`otp-input ${otpError ? "otp-input-error" : ""}`}
      inputMode="numeric"
      pattern="[0-9]*"

      onMultiDown={(e) => {
        const allowedKeys = [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "Tab"
        ];

        // ✅ Allow navigation & deletion
        if (allowedKeys.includes(e.key)) {
          return;
        }

        // ⛔ Block everything except digits
        if (!/^\d$/.test(e.key)) {
          e.preventDefault();
        }
      }}

      onPaste={(e) => {
        // ✅ Allow only numeric paste
        const pasted = e.clipboardData.getData("text");
        if (!/^\d+$/.test(pasted)) {
          e.preventDefault();
        }
      }}
    />
  )}
  containerStyle="otp-container"
/>



      {/* <div className="w-full flex justify-end mt-2">
        <span className="text-xs text-primary cursor-pointer">
          {seconds === 0
            ? "Resend OTP Code"
            : `Resend Code in ${formatTimeMinutes(seconds)}`}        
          </span>
      </div> */}

<div className="w-full flex justify-between items-center mt-2 mb-4">

  <span className="text-red-500 text-xs min-h-[16px]">
    {otpError}
  </span>

  <span
    className={`text-xs ${
      seconds === 0
        ? "text-primary cursor-pointer"
        : "text-gray-400 cursor-default"
    }`}
    onClick={seconds === 0 ? handleResendOtp : undefined}
  >
    {seconds === 0
      ? "Resend OTP Code"
      : `Resend Code in ${formatTimeMinutes(seconds)}`}
  </span>
</div>


      <CaptchaSection
        ref={captchaRef}
        onVerify={(token) => {
          setCaptchaToken(token || "");
          setCaptchaError(""); // Clear error when captcha is verified
          setOtpError(""); // Also clear OTP error when captcha is re-verified
        }}
      />

      {captchaError && (
        <p className="text-red-500 text-xs mt-1">{captchaError}</p>
      )}

      <button
        className={`mt-4 ${isSubmitEnabled ? "btn-primary cursor-pointer" : "bg-grey cursor-not-allowed"}`}
        disabled={!isSubmitEnabled}
        onClick={handleContinue}
      >
        Submit
      </button>
    </>
  );
};

export default OtpSection;
